export default "__VITE_ASSET__BFxNDceU__"